<mbsc-popup [options]="popupOptionsResourceFilter" [anchor]="popupAnchor" [buttons]="popupButtons" #popup>
  @if (!this.screenService.smallScreen && this.router.url ==='/admin-calendar') {
    <div class="mbsc-form-group">
      <div class="mbsc-form-group-title">Sonstige</div>
      @for (filter of filterResourcesService.otherFilters; track filter) {
        <div>
          <mbsc-checkbox [label]="filter.name" [checked]="tempFilters[filter.id]" (change)="handleCheckboxChange(filter.id)" />
        </div>
      }
    </div>
  }
  @if (!this.screenService.smallScreen) {
    <div class="mbsc-form-group">
      <div class="mbsc-form-group-title">Teams</div>
      @for (filter of filterResourcesService.teamFilters; track filter) {
        <div>
          <mbsc-checkbox [label]="filter.name" [checked]="tempFilters[filter.id]" (change)="handleCheckboxChange(filter.id)" />
        </div>
      }
    </div>
  }
  @if (!this.screenService.smallScreen) {
    <div class="mbsc-form-group">
      <div class="mbsc-form-group-title">Dolmetscher</div>
      @for (filter of filterResourcesService.interpreterFilters; track filter) {
        <div>
          <mbsc-checkbox [label]="filter.name" [checked]="tempFilters[filter.id]" (change)="handleCheckboxChange(filter.id)" />
        </div>
      }
    </div>
  }
  @if (this.screenService.smallScreen) {
    <div class="mbsc-form-group">
      <div class="mbsc-form-group-title">Dolmetscher</div>
      @for (filter of filterResourcesService.myFilters; track filter) {
        <div>
          <mbsc-checkbox
            [label]="filter.name"
            [checked]="tempFilters[filter.id]"
            [disabled]="filter.disabled"
            (change)="handleCheckboxChange(filter.id)"
            />
          </div>
        }
      </div>
    }
  </mbsc-popup>
